import React, {useState} from 'react';
import './Menu.scss';
import {useQueryClient} from "@tanstack/react-query";
import {USER_CURRENT_KEY} from "../../../api/public-voissa/users";
import createLink from "../../../libs/createLink";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faCameraWeb,
  faFire,
  faGear,
  faMemo,
  faRightFromBracket,
  faUserGroupSimple,
  faBookmark,
  faQuestionCircle,
  faBagShopping,
  faCrown,
  faCaretDown,
  faCaretRight,
  faBadgeCheck,
  faCamcorder
} from "@fortawesome/pro-regular-svg-icons";
import {useBreakpoint} from "../../../libs/breakpoint";
import useLogout from "../../../hooks/useLogout";
import useAbility from "../../../hooks/useAbility";
import { apiCropImage } from '../../../config';
import classNames from 'classnames';
import useRestriction from '../../../hooks/useRestriction';
import CONTENT_RESTRICTION_RULE from '../../../const/contentRestrictionRule';
import useAdblockDetector from "../../../hooks/useAdblockDetector";

const classGenders = {
  1: 'gender-man',
  2: 'gender-woman',
  3: 'gender-couple',
  4: 'gender-couple-lesbian',
  5: 'gender-couple-gay',
  6: 'gender-trav',
  guest: 'guest',
  group: 'group'
};
const MenuAvatar = ({currentUser}) => {
  let avatar = classGenders[currentUser?.profile?.gender || 1] || "gender-man";
  let src = `${process.env.PUBLIC_URL}/images/avatars/${avatar}.jpg`;

  if(currentUser?.profile?.avatar){
    src = apiCropImage({url: currentUser?.profile?.avatar, width: 28, height: 28});
  }
  return <img key={src} className='menu-item-avatar' src={src} alt={`${currentUser?.username} avatar`}/>
}

const Menu = ({...props}) => {

  const queryClient = useQueryClient();
  const logout = useLogout();
  const {can} = useAbility();
  const [toggleModerate, setToggleModerate] = useState(false);
  const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
  const isCurrentUser = !!currentUser?._id;
  const isUserPremium = currentUser?.subscription?.isPremium || false;
  const isWomenOrCoupleCertified = [2,3].includes(currentUser?.profile?.gender) && currentUser?.isCertified;
  const breakpoints = useBreakpoint();
  const isMobile = !!breakpoints.sm;
  const isAdBlocked = useAdblockDetector();
  const chatWebCamRestriction = useRestriction(CONTENT_RESTRICTION_RULE.CHAT_WEBCAM)


  const canReporting =  can({ action:'moderation', subject:'Reporting' });
  const canTMV =  can({ action:'verification', subject:'TagModeration' });
  const canTMT =  can({ action:'treatmentVideo', subject:'TagModeration' });

  return (
    <nav id='menu' {...props}>
      <div className='menu-wrapper'>
        {isCurrentUser && (
          <>
            <Link className='menu-item' to={createLink("userMe", currentUser)}><MenuAvatar currentUser={currentUser}/> Mon Profil</Link>
            {!isUserPremium && (
                <Link className='menu-item accent' to={createLink("subscription", currentUser)}>
                  <span className='accent'><FontAwesomeIcon icon={faCrown}/> {isWomenOrCoupleCertified ? "Soutenir avec Voissa Premium" : "Devenir Premium"}</span>
                </Link>
            )}
            
            <Link className='menu-item' to={createLink("userMeSettingsCertification", currentUser)}>
                <FontAwesomeIcon icon={faBadgeCheck} /> {currentUser.isCertified ? "Ma certification" : "Certifier mon compte"}
            </Link>
            <Link className='menu-item' to={createLink("userMeRelationsFriends", currentUser)}><FontAwesomeIcon icon={faUserGroupSimple} />Mes relations</Link>
            <Link className='menu-item' to={createLink("userMeFavories", currentUser)}><FontAwesomeIcon icon={faBookmark} />Mes favoris</Link>
            <Link className='menu-item' to={createLink("userMeSettings", currentUser)}><FontAwesomeIcon icon={faGear}/>Mes paramètres</Link>
          </>
        )}
        
        <div className="menu-item-group accent">
          <div className="menu-item-group-title">
            Recommandé par Voissa
          </div>
          <div className="menu-item-row">
          <Link className='menu-item' to={`${createLink('comparatorDating')}?source=${isMobile ? "tab-mobile" : "tab-desktop"}`}><FontAwesomeIcon icon={faFire} />Rencontres</Link>
          <a className='menu-item' target={isAdBlocked ? "_self" : "_blank"} rel={"noreferrer"} href={`https://tracker.emstat.fr/go/e7cd4972-eb9e-4b03-97e9-0246a8c3b157?key=hyyzi6c39awcate0xy2b&t=tab-voissa&source=${isMobile ? "tab-mobile" : "tab-desktop"}&spot=${isMobile ? "tab-mobile" : "tab-desktop"}&site=voissa`}><FontAwesomeIcon icon={faCamcorder} />Live Sex</a>
          </div>
        </div>
        <div className="menu-item-group">
          <div className="menu-item-group-title">
            Plus de rubriques
          </div>
          <div className="menu-item-row">
            <Link className='menu-item' to={createLink("stories")}><FontAwesomeIcon icon={faMemo}/>Histoires</Link>
            <a className='menu-item' target={isAdBlocked ? "_self" : "_blank"} rel={"noreferrer"} href={"https://voissa.boutique"}><FontAwesomeIcon icon={faBagShopping}/>Boutique</a>
            {chatWebCamRestriction.isRestricted ? (
                <span className='menu-item' onClick={() => chatWebCamRestriction.restrictionHandler()}><FontAwesomeIcon icon={faCameraWeb}/>Chat-webcam</span>
            ) : (
                <Link className='menu-item' to={createLink("chatWebcam")}><FontAwesomeIcon icon={faCameraWeb}/>Chat-webcam</Link>
            )}
            
          </div>
        </div>

        {isCurrentUser && (
            <>
              <div className={classNames('menu-item', {open: toggleModerate})} onClick={()=>setToggleModerate(!toggleModerate)}><FontAwesomeIcon icon={toggleModerate ? faCaretDown : faCaretRight}/>Modération</div>
              {toggleModerate && (
                <>
                  {canReporting && (<Link className='menu-item' to={createLink("pcModerator")}><FontAwesomeIcon icon={faQuestionCircle}/>PC Modérateur</Link>)}
                  <Link className='menu-item' to={createLink("tagModerationQualifications")}><FontAwesomeIcon icon={faQuestionCircle}/>Publications à catégoriser</Link>
                  {canTMV && (<Link className='menu-item' to={createLink("tagModerationVerifications")}><FontAwesomeIcon icon={faQuestionCircle}/>Publications à vérifier</Link>)}
                  {canTMT && (<Link className='menu-item' to={createLink("tagModerationTreatmentVideo")}><FontAwesomeIcon icon={faQuestionCircle}/>Gestion de la timeline des vidéos</Link>)}
                </>
              )}
              
            </>
        )}
        
      </div>
      {isCurrentUser && (
        <ul className='menu-wrapper-outer'>
          <li className='menu-item-outer logout' onClick={() => logout()}><FontAwesomeIcon icon={faRightFromBracket} />Me déconnecter</li>
        </ul>
      )}
      <ul className='menu-wrapper-outer' style={{marginTop: 'auto', paddingTop: '24px'}}>
        <li className='menu-item-outer'><Link to={createLink("parentalControl")}>Contrôle parental</Link></li>
        <li className='menu-item-outer'><Link to={createLink("trustSecurity")}>Confiance et sécurité</Link></li>
        <li className='menu-item-outer'><Link to={createLink("charter")}>Charte</Link></li>
        <li className='menu-item-outer'><Link to={createLink("cgus")}>Mentions légales</Link></li>
        <li className='menu-item-outer'><Link to={createLink("contact")}>Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Menu;
